
export class NewHireDBModel {
    Id: number;
    GroupId: number;
    FinalQuoteId: number;
    NewHireInfo: string;
    MedicalPackage: string='';
    ShareFileUrl: string='';
    ShareFileLinkExpiry: string;
    CreatedBy: string;
    CreatedDate: string;
    UpdatedBy: string;
    UpdatedDate: string;
}